import React from "react";
import HomeIcon from '@mui/icons-material/Home';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AirIcon from '@mui/icons-material/Air';
import BookIcon from '@mui/icons-material/Book';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import FlareIcon from '@mui/icons-material/Flare';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import CycloneIcon from '@mui/icons-material/Cyclone';
import AnimationIcon from '@mui/icons-material/Animation';
import Diversity2Icon from '@mui/icons-material/Diversity2';

const menus = [
    {
        label: 'Drehmoment',
        type: "section",
        children: [
            {
                uri: "/",
                label: 'sidebar.menuItem.home',
                type: "nav-item",
                icon: <HomeIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/a14ca8d5-3f20-40cb-ab9c-a523fd2baf73",
                label: 'sidebar.menuItem.sensualHeeling',
                type: "nav-item",
                icon: <FavoriteBorderIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/1685562f-9b20-465a-ac1f-7eba39050556",
                label: 'sidebar.menuItem.fluidFoundations',
                type: "nav-item",
                icon: <CycloneIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/c318483b-0653-4136-9515-6ea280b20c86",
                label: 'sidebar.menuItem.elevatedEssence',
                type: "nav-item",
                icon: <AnimationIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/549dcfbf-30f0-46cd-afdf-d75fe1b20f42",
                label: 'sidebar.menuItem.seductiveSilk',
                type: "nav-item",
                icon: <Diversity2Icon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/e52f8ec6-f942-4a6d-8c32-2c175711529e",
                label: 'sidebar.menuItem.mobilityFlow',
                type: "nav-item",
                icon: <AirIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/4bbd0b72-48e5-4b3b-a040-d2cc113add8e",
                label: 'sidebar.menuItem.holisticHeels',
                type: "nav-item",
                icon: <AutoAwesomeIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/a66eb18e-f535-42ec-afd2-5abadb430eb9",
                label: 'sidebar.menuItem.infinityFlow',
                type: "nav-item",
                icon: <AllInclusiveIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/e6be7d9e-f864-409e-849e-36b62b23b7f6",
                label: 'sidebar.menuItem.hooked',
                type: "nav-item",
                icon: <FlareIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/48abf3cf-8bba-4f8a-87db-1fa2ae6bdfee",
                label: 'sidebar.menuItem.bodyfulBreathing',
                type: "nav-item",
                icon: <AccessibilityNewIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/categories/34057ad4-b16d-424c-b9f3-c2e1e5e60be3",
                label: 'sidebar.menuItem.headOverHeels',
                type: "nav-item",
                icon: <ElectricBoltIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/library",
                label: 'sidebar.menuItem.myLibrary',
                type: "nav-item",
                icon: <BookIcon sx={{fontSize: 20}}/>
            },

            /*
            {
                uri: "/campaigns",
                label: 'sidebar.menuItem.campaigns',
                type: "nav-item",
                icon: <CampaignIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/brand-voices",
                label: 'sidebar.menuItem.brandVoice',
                type: "nav-item",
                icon: <GraphicEqIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/saved-content",
                label: 'sidebar.menuItem.savedContent',
                type: "nav-item",
                icon: <BookmarkIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/team",
                label: 'sidebar.menuItem.team',
                type: "nav-item",
                icon: <WorkspacesIcon sx={{fontSize: 20}}/>
            },
            */
        ]
    },
];

export default menus;
